import { IonButton, IonCol, IonRow, IonSearchbar } from "@ionic/react";
import React, { useContext, useEffect, useState } from "react";
import { utilService } from "../../../../services";
import { NurseContext } from "../../NurseManagement";
import { NurseManagementService } from "../../NurseManagementService";
import {
  GetUnitNurseListResponse,
  UnitNurseData,
} from "../../NurseMgmtDataModels";
import Loader from "../../../../components/Shared/Loader/Loader";
import { useToast } from "@agney/ir-toast";
import { useTranslation } from "react-i18next";

interface SelectNurseProps {
  unitsList: [];
  resetData: boolean;
  setSelectedNurseGuid: Function;
  setSelectedNurseId: Function;
  setActiveTabInMobile: Function;
}

const SelectNurse: React.FunctionComponent<SelectNurseProps> = (props) => {
  const Toast = useToast();
  const { t } = useTranslation("nursemanagement");
  const nurseContextData = useContext(NurseContext);

  const [nursesList, setNursesList]: [[], Function] = useState([]);
  const [searchedNurse, setSearchedNurse] = useState("");
  const [searchedNursesList, setSearchedNursesList]: [[], Function] = useState(
    []
  );
  const [showLoader, setShowLoader]: [boolean, Function] = useState(false);

  useEffect(() => {
    props.resetData && setSearchedNursesList([]);
    setNursesList([]);
  }, [props.resetData]);

  useEffect(() => {
    nurseContextData.selectedUnit &&
      getNurseList(nurseContextData.selectedUnit);
  }, [nurseContextData.selectedUnit]);

  const getNurseList = async (selectedUnit: string) => {
    setShowLoader(true);
    const nursesData: GetUnitNurseListResponse =
      await NurseManagementService.getNurses({
        unitId: selectedUnit,
        reg_code: utilService.getNetwork(),
      });
    if (nursesData.isSuccess) {
      setNursesList(nursesData.result);
    } else {
      setNursesList([]);
      Toast.error(nursesData.message);
    }
    setShowLoader(false);
  };

  const getSearchedNurseList = async (searchedName: string) => {
    setShowLoader(true);
    const siteId = NurseManagementService.getSiteIdForUnit(
      props.unitsList,
      +nurseContextData.selectedUnit
    );
    const nursesData: GetUnitNurseListResponse =
      await NurseManagementService.getSearchedNurses({
        sid: siteId,
        name: searchedName,
        reg_code: utilService.getNetwork(),
      });
    if (nursesData.isSuccess) {
      setSearchedNursesList(nursesData.result);
    } else {
      setSearchedNursesList([]);
      Toast.error(nursesData.message);
    }
    setShowLoader(false);
  };

  const handleSearch = (event: any) => {
    // event.persist();
    setSearchedNurse(event.target.value);
    event.target.value && getSearchedNurseList(event.target.value);
  };

  const checkIfNurseNotAdded = (guid: string) => {
    if (nursesList.length) {
      return utilService.findObjectIndex(nursesList, "guid", guid) === -1
        ? true
        : false;
    } else {
      return true;
    }
  };

  const handleNurseAdd = async (nurse: UnitNurseData) => {
    const nurseAddResponse: GetUnitNurseListResponse =
      await NurseManagementService.addNurse({
        nid: nurse.id,
        unit_id: nurseContextData.selectedUnit,
        reg_code: utilService.getNetwork(),
      });
    if (nurseAddResponse.isSuccess) {
      setNursesList([...nursesList, nurse]);
      Toast.success(t("nurseAddedSuccessfully"));
    } else {
      Toast.error(nurseAddResponse.message);
    }
  };

  const selectNurse = (nurse: UnitNurseData) => {
    props.setSelectedNurseGuid(nurse.guid);
    props.setSelectedNurseId(nurse.id);
  };

  return (
    <div className="card-container w-100">
      <h5 className="header-text">{t("selectNurse")}</h5>
      {(nursesList.length > 0 ||
        (searchedNurse && searchedNursesList.length === 0)) && (
        <IonRow>
          <IonCol col-md="12" col-lg="6" size="6">
            <IonSearchbar
              debounce={1000}
              placeholder={t("search")}
              value={searchedNurse}
              onIonChange={(e) => handleSearch(e)}
            ></IonSearchbar>
          </IonCol>
        </IonRow>
      )}
      {showLoader && (
        <div className="loader-container">
          <Loader></Loader>
        </div>
      )}
      {(nursesList.length > 0 && !searchedNurse) ||
      searchedNursesList.length > 0 ? (
        <div className="card-content">
          {nursesList.length > 0 && !searchedNurse && (
            <IonRow>
              <IonCol size="12">
                <ul className="ul-list">
                  {nursesList.map((nurse: UnitNurseData, index: number) => {
                    return (
                      <li key={nurse.id}>
                        <div
                          className={`list-val-container d-flex align-items-center clickable ${
                            nurse.guid === nurseContextData.selectedNurseGuid
                              ? "selected"
                              : ""
                          }`}
                          onClick={() => selectNurse(nurse)}
                        >
                          <span className="name-icon">
                            {nurse.name?.charAt(0).toUpperCase()}
                          </span>
                          <span className="list-val" key={nurse.id + index}>
                            {nurse.name}
                          </span>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </IonCol>
            </IonRow>
          )}
          {searchedNursesList.length > 0 && searchedNurse && (
            <IonRow>
              <IonCol size="12">
                <ul className="ul-list">
                  {searchedNursesList.map(
                    (nurse: UnitNurseData, index: number) => {
                      return (
                        <li key={nurse.id}>
                          <div
                            className={`list-val-container d-flex align-items-center ${
                              nurse.guid === nurseContextData.selectedNurseGuid
                                ? "selected"
                                : ""
                            } ${
                              !checkIfNurseNotAdded(nurse.guid)
                                ? "clickable"
                                : ""
                            }`}
                            onClick={() => {
                              !checkIfNurseNotAdded(nurse.guid) &&
                                selectNurse(nurse);
                            }}
                          >
                            <span className="name-icon">
                              {nurse.name?.charAt(0).toUpperCase()}
                            </span>
                            <span className="list-val" key={nurse.id + index}>
                              {nurse.name}
                            </span>
                          </div>
                          {checkIfNurseNotAdded(nurse.guid) && (
                            <IonButton
                              className="primary-transparent-btn"
                              onClick={() => handleNurseAdd(nurse)}
                            >
                              {t("add")}
                            </IonButton>
                          )}
                        </li>
                      );
                    }
                  )}
                </ul>
              </IonCol>
            </IonRow>
          )}
        </div>
      ) : (
        <div className="card-content d-flex justify-content-center align-items-center">
          <IonRow>
            <IonCol size="12">
              <div className="no-content-msg">
                <div className="no-data-icon icon-no_nurse mb-3"></div>
                <div>{t("noNurses")}</div>
              </div>
            </IonCol>
          </IonRow>
        </div>
      )}
      <div className="mobile-nav-buttons">
        <IonButton
          className="button tertiary-btn btn-curved"
          disabled={nurseContextData.selectedNurseGuid === ""}
          onClick={() => props.setActiveTabInMobile(2)}
        >
          {t("next")}
        </IonButton>
      </div>
    </div>
  );
};

export default SelectNurse;
